export class UserProfileConstants {

    readonly MS_PROFILE_TOUR: string = "10000000-0000-0000-0000-000000000000";
    readonly MS_PROFILE_TOUR_VERSION: number = 1;


    readonly MS_PROFILE_MODAL_TOUR: string = "11000000-0000-0000-0000-000000000000";
    readonly MS_PROFILE_MODAL_TOUR_VERSION: number = 1;

  }